interface ArticleBodyProps {
  content: string[];
}

export default function ArticleBody({ content }: ArticleBodyProps) {
  return (
    <div className="article-body text-[15px] leading-[1.9] text-foreground-700">
      {content.map((line, index) => {
        if (line.startsWith('## ')) {
          return (
            <h2
              key={`${index}-h2`}
              id={`section-${index}`}
              className="scroll-mt-24 pt-4 font-heading text-xl font-bold text-foreground-950 md:text-2xl"
            >
              {line.slice(3)}
            </h2>
          );
        }
        if (line.startsWith('### ')) {
          return (
            <h3 key={`${index}-h3`} className="pt-2 font-heading text-lg font-semibold text-foreground-900">
              {line.slice(4)}
            </h3>
          );
        }
        if (line.startsWith('> ')) {
          return (
            <blockquote
              key={`${index}-quote`}
              className="rounded-md border-l-4 border-accent-400 bg-accent-50 px-5 py-4 font-heading text-base text-foreground-800"
            >
              {line.slice(2)}
            </blockquote>
          );
        }
        return (
          <p key={`${index}-p`} className="text-justify">
            {line}
          </p>
        );
      })}
    </div>
  );
}